export enum ResultsAction {
  SetCustomASBVs = 'SetCustomASBVs',
  SetDisplay = 'SetDisplay',
  SetTopPercentile = 'SetTopPercentile',
  SetBottomPercentile = 'SetBottomPercentile',
  SetSortByASBV = 'SetSortByASBV',
}
